import type { SubmissionFile } from './types.ts';

export type ExpiryState = 'none' | 'ok' | 'expiring' | 'expired';

// Files within this many days of `expires_at` are flagged as expiring.
export const EXPIRY_WARNING_DAYS = 14;

export function expiryState(
  file: Pick<SubmissionFile, 'expires_at'>,
  now: Date = new Date(),
): ExpiryState {
  if (!file.expires_at) return 'none';
  const when = new Date(file.expires_at).getTime();
  if (Number.isNaN(when)) return 'none';
  const nowMs = now.getTime();
  if (when <= nowMs) return 'expired';
  const days = (when - nowMs) / (24 * 60 * 60 * 1000);
  if (days <= EXPIRY_WARNING_DAYS) return 'expiring';
  return 'ok';
}

// Convert an ISO timestamp string from the API to the `YYYY-MM-DD` form a
// `<input type="date">` accepts, or '' if absent.
export function toDateInput(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const year = d.getUTCFullYear();
  const month = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Convert a `YYYY-MM-DD` value back to an ISO timestamp at end-of-day UTC
// (so the file is considered valid through the whole calendar day).
export function fromDateInput(value: string): string | null {
  if (!value) return null;
  const parsed = new Date(`${value}T23:59:59.000Z`);
  if (Number.isNaN(parsed.getTime())) return null;
  return parsed.toISOString();
}
